
// 表单验证
String.prototype.trim = function()  
{  
    return this.replace(/(^\s*)|(\s*$)/g, "");  
}  

//是否为纯数字
String.prototype.IsPureNum = function(){
    var reg = /^(\d+)$/; 
    var source = this.trim()
    return source.match(reg)
}

//长度是否小于某个值
String.prototype.shorterThan = function(len){
    return this.length <= len
}

//是否合法
String.prototype.isLegal = function(){
    var reg = /select|update|delete|exec|count|'|"|=|;|>|<|%/i
    var source = this.trim()
    console.log(!reg.test(source))
    return !reg.test(source)
}

//是否为手机
String.prototype.isPhone = function(){
    var reg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1}))+\d{8})$/
    var source = this.trim()
    return source.match(reg)
}



// WEBPACK FOOTER //
// ./src/utils/valid.js